export default "__VITE_ASSET__B91_QtPk__"